import axios, { AxiosRequestConfig } from 'axios';

export const request = async (
  request: Partial<AxiosRequestConfig>,
): Promise<unknown> => {
  const response = await axios.request(request);
  return response.data;
};
